// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"a988acc6","147":"179ef4d7","348":"726b3f3e","737":"d9feb704","940":"b60f9314"}[chunkId] + ".chunk.js";
};